
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/welcome",
      function () {
        return require("private-next-pages/about/welcome.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/welcome"])
      });
    }
  